export default __webpack_public_path__ + "static/media/parked_sale_notification.60f7268a.wav";